<template>
  <div id="home">
    <div class="px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
      <h1 class="display-4 mr-2"><strong>Data</strong> Pool</h1>
      <p class="lead mt-3">FX and Crypto rates, Stock quotes, Commodity prices and more<br>
        easily and uniformly accessible</p>
    </div>

    <div class="card-deck mb-3 text-center">
      <div class="card mb-4 shadow-sm">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Free</h4>
        </div>
        <div class="card-body">
          <h1 class="card-title pricing-card-title">$0 <small class="text-muted">/ mo</small></h1>
          <ul class="list-unstyled mt-3 mb-4">
            <li>Web UI</li>
            <li>JSON REST API</li>
            <li>Limited Requests</li>
            <li style="color: white;">.</li>
            <li style="color: white;">.</li>
          </ul>
          <button type="button" class="btn btn-lg btn-block btn-primary" v-on:click="$parent.selected='Browse'">Get started now</button>
        </div>
      </div>
      <div class="card mb-4 shadow-sm">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Pro</h4>
        </div>
        <div class="card-body">
          <h1 class="card-title pricing-card-title">$99 <small class="text-muted">/ mo</small></h1>
          <ul class="list-unstyled mt-3 mb-4">
            <li>Web UI with Pro Mode</li>
            <li>JSON, CSV and XML API</li>
            <li>Unlimited Requests</li>
            <li>Phone and email support</li>
            <li style="color: white;">.</li>
          </ul>
          <a class="btn btn-lg btn-block btn-outline-primary" href="mailto:adrian.rabenseifner@silversky.ch">Contact us</a>
        </div>
      </div>
      <div class="card mb-4 shadow-sm">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Enterprise</h4>
        </div>
        <div class="card-body">
          <h1 class="card-title pricing-card-title">$ <small class="text-muted">on request</small></h1>
          <ul class="list-unstyled mt-3 mb-4">
            <li>Dedicated UI and server</li>
            <li>JSON, CSV, XML and SQL API</li>
            <li>Customized API features</li>
            <li>Customized data sources</li>
            <li>on-premise installation</li>
          </ul>
          <a class="btn btn-lg btn-block btn-outline-primary" href="mailto:adrian.rabenseifner@silversky.ch">Contact us</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
